import React from 'react';

import { BrandButton, ButtonText, StyledLink } from './styles';

const ConditionalLinkWrapper = ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;

const Button = ({
  color,
  variant,
  boxShadow,
  children,
  disabled,
  fullWidth,
  onClick,
  size,
  icon,
  link,
  href,
  className,
  hidden,
  startIcon,
  type,
}) => {
  if (hidden) return null;

  return (
    <ConditionalLinkWrapper
      condition={link}
      wrapper={(children) => <StyledLink href={href}>{children}</StyledLink>}
    >
      <BrandButton
        color={color}
        variant={variant}
        boxShadow={boxShadow}
        disabled={disabled}
        fullWidth={fullWidth}
        onClick={onClick}
        size={size}
        href={href}
        className={className}
        type={type}
      >
        {startIcon}
        <ButtonText size={size} color={color} variant={variant}>
          {children}
        </ButtonText>
        {icon}
      </BrandButton>
    </ConditionalLinkWrapper>
  );
};

BrandButton.defaultProps = {
  color: 'primary',
  variant: 'contained',
  shadowColor: null,
  disabled: false,
  fullWidth: false,
};

export default Button;
